import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { isNotEmpty } from "@/libs/tools";
@Component({
    name: "FillBlankExam",
    components: {}
})
export default class FillBlankExam extends Vue {
    @Prop() private num: number;
    @Prop() private isAnsweringQuestion: boolean;
    @Prop() private item: any;

    @Emit()
    checkUserAnswer() {
        let answer = (this.$refs["fillBlankAnswer"] as any).value;
        let endTime = new Date();

        if (isNotEmpty(answer)) {
            return { num: this.num, answer: answer, endTime: endTime };
        } else {
            return "";
        }
    }
}

//@ts-ignore
export { default as FillBlankExam } from "./index.vue";
